<template>
  <div>
    <vue-editor
        ref="editor"
        useCustomImageHandler
        :placeholder="placeholder"
        @image-added="handleImageAdded"
        :value="value"
        @input="(val) => $emit('input', val)"></vue-editor>
  </div>
</template>

<script>
const imageRegex = new RegExp(/<img[^>]+src="(http:\/\/[^">]+)"/g)
const imgRex = /<img[^>]+src="(https:\/\/[^">]+)"/g;
import { VueEditor, Quill } from 'vue2-editor'
import axios from "axios";

export default {
  name: "Vue2CustomEditor",
  components: {
    VueEditor
  },
  computed: {
    uploadedImagesArray() {
      const images = []
      let img
      while ((img = imgRex.exec(this.value))) {
        images.push(img[1])
      }
      return images
    },
    removedImages() {
      return this.stateImagesArray.filter(x => !this.uploadedImagesArray.includes(x))
    }
  },
  props: {
    value: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      stateImagesArray: [],
    }
  },
  mounted() {
    this.$refs.editor.quill.clipboard.addMatcher('IMG', (node, delta) => {
      const Delta = Quill.import('delta')
      return new Delta().insert('')
    })
    this.$refs.editor.quill.clipboard.addMatcher('PICTURE', (node, delta) => {
      const Delta = Quill.import('delta')
      return new Delta().insert('')
    })
  },
  methods: {
    setImagesState() {
      console.log('this.valuethis.valuethis.valuethis.valuethis.valuethis.value', this.value)
      const images = []
      let img
      while ((img = imgRex.exec(this.value))) {
        images.push(img[1])
      }
      this.stateImagesArray = images
      return this.stateImagesArray
    },
    handleImageAdded: function(file, Editor, cursorLocation, resetUploader) {
      let loader = this.$loading.show();
      const formData = new FormData();
      formData.append('file', file);

      axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
      axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
      axios
          .post(`/api/v1/files/createNewTmpFile?companyId=${this.$route.query.companyId}`, formData, {'Content-Type': 'multipart/form-data'})
          .then(response => {
            // this.$emit('handleImageAdded', response.data.file)
              setTimeout(()=> {
                Editor.insertEmbed(cursorLocation, 'image', response.data.file.pathToDownload);
                resetUploader();
                loader.hide();
                this.$refs.editor.$refs.fileInput.value = null
              }, 4000)
          })
          .catch(error => {
            console.log('An error occurred:', error);
            loader.hide();
          })
    }
  }
}
</script>

<style scoped>

</style>
